import { stripHtml } from 'string-strip-html';
import { Voices, Personas } from 'aicoach/config';

export const StatusChoices = [
	{ id: 'active', name: 'Active' },
	{ id: 'inactive', name: 'Inactive' }
];

export const TimeLimitChoices = [];

for ( let id=0; id < 31; id++ ) {
	let name = `${id} minutes`;
	if ( id === 0 ) {
		name = 'Unlimited';
	} else if ( id === 1 ) {
		name = `${id} minute`;
	}

	TimeLimitChoices.push( { id, name } );
}

export const DefaultValues = {
	"status": "active",
	"persona_id": 1,
	"public": 0
};

export const voiceoverOptionText = r => {
	let { name, content } = r;
	let label = name;
	content = stripHtml( content ).result;

	if ( content ) {
		const contentFrag = content.length > 30 ? content.substring( 0, 30 ) + '...' : content;
		label += ' - ' + contentFrag;
	}
	
	return label;
};

export const VoiceChoices = Object.entries( Voices ).map( ([ id, v ]) => ({ id, name: v.name }) );
export const PersonaChoices = Object.entries( Personas ).map(([ id, v ]) => ({ id, name: v.name }) );